module.exports = __webpack_public_path__ + "static/media/quotation-marks.126d6cb5.svg";